import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PhoneIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PhoneGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M8.78811 3.95003L8.7887 3.9498L8.7887 3.9498C9.02905 3.85589 9.29505 3.96779 9.40195 4.20335L9.40199 4.20344L11.6571 9.18932C11.7449 9.38309 11.7018 9.61327 11.5491 9.76014L10.5495 10.7217L10.5494 10.7217C10.4262 10.8401 10.4039 11.0359 10.5016 11.1876L10.5016 11.1876C10.797 11.6466 11.1462 12.0848 11.5387 12.4897C11.9152 12.8781 12.3247 13.2213 12.7559 13.5096C12.8983 13.6044 13.0763 13.5856 13.1909 13.4658L13.1909 13.4657L14.4225 12.1806L8.78811 3.95003ZM8.78811 3.95003L5.27519 5.35329C5.27519 5.35329 5.27519 5.35329 5.27519 5.35329M8.78811 3.95003L5.27519 5.35329M19.8053 14.4062L19.8053 14.4062C20.036 14.5174 20.1415 14.7915 20.0511 15.0328L18.6929 18.6678L18.6929 18.6678C18.3903 19.477 17.6552 20.0283 16.8177 20.0695L16.8177 20.0695C16.6434 20.0781 16.4549 20.0833 16.2543 20.0833C14.1647 20.0833 10.7176 19.5246 7.71191 16.4237C4.47496 13.0842 3.94484 9.34175 3.91691 7.40783L19.8053 14.4062ZM19.8053 14.4062L14.9726 12.0794M19.8053 14.4062L14.9726 12.0794M5.27519 5.35329C4.44847 5.68346 3.90353 6.50938 3.91691 7.40779L5.27519 5.35329ZM14.9726 12.0794C14.7863 11.9891 14.5654 12.0313 14.4226 12.1805L14.9726 12.0794ZM4.88357 7.3929L4.88356 7.39285C4.87627 6.90627 5.17499 6.458 5.62608 6.27779C5.62608 6.27779 5.62608 6.27779 5.62608 6.27779L8.71617 5.04354L10.6329 9.28185L9.88864 9.99787C9.88863 9.99788 9.88862 9.99789 9.88862 9.99789C9.41866 10.4497 9.33846 11.1797 9.69463 11.7343L9.6947 11.7344C10.0263 12.249 10.4161 12.7385 10.8534 13.1893C11.2773 13.6266 11.74 14.014 12.2286 14.341L12.2286 14.341C12.7509 14.6899 13.4466 14.6137 13.8804 14.1614L13.8804 14.1613L14.8718 13.1266L18.9879 15.1085L17.7907 18.3124C17.624 18.7572 17.2231 19.0565 16.7713 19.0785L16.7711 19.0785C14.9457 19.1717 11.4286 18.8516 8.39723 15.7242C5.39933 12.6313 4.90916 9.1766 4.88357 7.3929Z"
        fill="#696969"
        stroke="#696969"
        strokeWidth="0.166667"
      />
    </svg>
  );
};

export default PhoneIcon;
